// extracted by mini-css-extract-plugin
export default {"successBox":"QHxT2glCgtMqWl45lXiL4"};